<template>
    <div class="imgItem df jcfs aic" @mouseover="mouseoverFun" @mouseleave="mouseleaveFun" >
        <div class="pr" :style="'width:'+width+';height: '+height+';margin-bottom:'+(nameShow && name && name.length > 0 ? 20 : 0)+'px;'">
            <slot></slot>

            <div class="wp100 h20 pa_bl hi" style="bottom:-20px;" v-if="nameShow && name && name.length > 0">{{ name }}</div>
        </div>
    </div>
</template>
  
<script>
  export default {
    name: 'imgItem',
    props: {

        width:{
            type:String,
            default:'auto'
        },

        height:{
            type:String,
            default:'40px'
        },

        nameShow:{
            type:Boolean,
            default:true
        },
        
        name:{
            type:String,
            default:''
        }
    },

    data(){

        return {
            
        }
    },

    created(){
    },

    methods:{
		mouseoverFun(e){

            var mouseenterOffLeftRight = false;

            var wPicShow = parseFloat(window.innerWidth);
            var xPicShow = parseFloat(e.pageX);

            if(xPicShow > (wPicShow / 2)){
                mouseenterOffLeftRight = true;
            }else{
                mouseenterOffLeftRight = false;
            }

            
            var src = this.$slots.default()[0].props.src;
			this.$root.imgShow(src,mouseenterOffLeftRight,this.name)
		},

        mouseleaveFun(){
			this.$root.imgHide()
        }
    }
  }
  </script>
  
  <style  lang="less">
  .imgItem{
    width: auto;

    img{
        height: 100%;
    }
  }
  </style>
  